import { BlockNoteEditor } from '@blocknote/core';
import { BlockSchema } from '../schema';
import ensureParagraphAfterBlockAndFocus from './ensure-paragraph-after-block-and-focus';

export default function scheduleEnsureParagraphAfterImageUpload(
  editor: BlockNoteEditor<BlockSchema>,
  blockId: string | undefined,
  uploadResult: string | undefined,
) {
  if (!blockId || !uploadResult) {
    return;
  }

  const run = () => {
    if (!editor.domElement) {
      return;
    }
    ensureParagraphAfterBlockAndFocus(editor, blockId);
  };

  if (editor.domElement) {
    setTimeout(run, 0);
    return;
  }

  editor.onMount(() => {
    setTimeout(run, 0);
  });
}
